import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class BodyOverlay extends ThemeComponent {
    init() {
        document.addEventListener('openSizeDrawer', () => {
            this.classList.add('is-active');
        });
        document.addEventListener('closeSizeDrawer', () => {
            this.classList.remove('is-active');
        });
    }
}
